export default __webpack_public_path__ + "static/media/withholdingImg.bf344f14.svg";